export var SchedulerLabel;
(function (SchedulerLabel) {
    SchedulerLabel["TIMETABLE"] = "Timetable";
    SchedulerLabel["BIAS"] = "Offset";
    SchedulerLabel["BIAS_START"] = "Start Offset";
    SchedulerLabel["BIAS_END"] = "End Offset";
    SchedulerLabel["ONLINE_STATUS"] = "Status";
    SchedulerLabel["LOCAL_OVERRIDE"] = "Local Override";
    SchedulerLabel["LIGHT_SENSOR_SOURCE"] = "Light Sensor Source";
    SchedulerLabel["LIGHT_SENSOR_PORT"] = "Light Sensor Port";
    SchedulerLabel["LIGHT_SENSOR_READING"] = "Light Sensor Reading";
    SchedulerLabel["THRESHOLD"] = "Threshold";
    SchedulerLabel["HYSTERESIS"] = "Hysteresis";
    SchedulerLabel["DELAY"] = "Delay";
})(SchedulerLabel || (SchedulerLabel = {}));
